import React, { useState } from 'react'
import {galleryData } from '../arrImages'
import styles from './Gallery.module.scss'
import Modal from './Modal'

const Gallery = () => {
    const [clickedImg, setClickedImg] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [currentDescription, setDescription] = useState(null);

    const handelClick = (item, index) => {
        setCurrentIndex(index);
        setClickedImg(item.image);
        setDescription(item.description)
    };

    const handelRotationRight = () => {
        const newIndex = (currentIndex + 1) % galleryData.length
        const newItem = galleryData[newIndex]

        setCurrentIndex(newIndex)
        setClickedImg(newItem.image)
        setDescription(newItem.description)
    }

    const handelRotationLeft = () => {
        const newIndex = (currentIndex - 1 + galleryData.length) % galleryData.length
        const newItem = galleryData[newIndex]

        setCurrentIndex(newIndex)
        setClickedImg(newItem.image)
        setDescription(newItem.description)
    }

  return (
        <div className={styles.galleryList}>
            {galleryData.map((item, index)=>(
                <div key={item.id} className={styles.galleryItem} onClick={() => handelClick(item, index)}>
                    <div className={styles.galleryItemHover}></div>
                    <img src={item.image} width="1600" height="1200" alt={item.description} loading="lazy" decoding="async"/>
                </div>
            ))}
            {clickedImg && (
                <Modal
                    clickedImg={clickedImg}
                    currentIndex={currentIndex}
                    currentDescription={currentDescription}
                    handelRotationRight={handelRotationRight}
                    handelRotationLeft={handelRotationLeft}
                    setClickedImg={setClickedImg}
                />
            )}
        </div>
    )
}

export default Gallery
